
import { ReactNode } from "react";
import PageLayout from "./PageLayout";
import { LegalAssistanceSheet } from "../legal/LegalAssistanceSheet";

interface LegalPageLayoutProps {
  title: string;
  children: ReactNode;
  lastUpdated?: string;
  hideAssistanceSheet?: boolean;
  bgClass?: string;
}

export const LegalPageLayout = ({
  title,
  children,
  lastUpdated,
  hideAssistanceSheet = false,
  bgClass = "bg-white"
}: LegalPageLayoutProps) => {
  return (
    <PageLayout title={title} description={lastUpdated ? `Last updated: ${lastUpdated}` : "Important legal information about using Offertio"}>
      <div className={`${bgClass}`}>
        <div className="container mx-auto p-4 py-8">
          <div className="flex flex-col md:flex-row gap-8">
            <div className={hideAssistanceSheet ? "w-full" : "md:w-3/4"}>
              <div className="bg-white rounded-lg shadow-sm p-8 border border-gray-100">
                {children}
              </div>
            </div>
            
            {!hideAssistanceSheet && <LegalAssistanceSheet />}
          </div>
        </div>
      </div>
    </PageLayout>
  );
};
